export default __webpack_public_path__ + "static/media/t_shirt_blue_original.a15eaee9.jpg";